import * as React from 'react';

// This is used for a body of react-tiny-popover library

interface PopoverMenuProps {
    items: { label: string; action: (e) => void }[];
}

const PopoverMenu: React.FC<PopoverMenuProps> = ({
    items
}: PopoverMenuProps) => {
    return (
        <div className="popover--menu">
            {items.map((item, index) => (
                <div
                    key={index}
                    onClick={(e) => item.action(e)}
                    className="popover--menu--item"
                >
                    {item.label}
                </div>
            ))}
        </div>
    );
};

export default PopoverMenu;
